<template>
  <div>
    <!-- 标签页 -->
    <Card>
      <Tabs v-model="activeTab" type="card">
        <TabPane label="学校信息管理" name="school">
          <div class="tab-content">
            <!-- 搜索区域 -->
            <div class="search-con search-con-top">
              <Input
                class="search-input"
                v-model="schoolSearchVal"
                style="padding:5px; width: 300px;"
                placeholder="输入学校名称、学校代码或联系人搜索"
                @on-enter="handleSchoolSearch"
                clearable
              />
              <Button type="primary" icon="ios-search" @click="handleSchoolSearch" class="search-btn">搜索</Button>
              <Button type="primary" icon="ios-add" @click="showSchoolAddModal" class="search-btn">新增学校信息</Button>
              <Button type="success" icon="ios-cloud-upload" @click="showSchoolImportModal" class="search-btn">导入</Button>
              <Button type="warning" icon="ios-download-outline" @click="handleSchoolExport" class="search-btn">导出</Button>
              <Button type="info" icon="ios-download-outline" @click="handleSchoolDownloadTemplate" class="search-btn">下载模板</Button>
            </div>

            <Spin size="large" fix v-if="schoolLoading"></Spin>

            <!-- 数据表格 -->
            <Table
              ref="schoolTable"
              :columns="schoolColumns"
              :data="schoolTableData"
              :loading="schoolLoading"
              border
              size="small"
            >
            </Table>

            <!-- 分页 -->
            <div class="pagination-con">
              <Page
                :total="schoolTotal"
                :page-size="schoolPageSize"
                :current="schoolCurrentPage"
                show-sizer
                show-total
                @on-change="handleSchoolPageChange"
                @on-page-size-change="handleSchoolPageSizeChange"
              />
            </div>
          </div>
        </TabPane>

        <TabPane label="毕业信息管理" name="graduate">
          <div class="tab-content">
            <!-- 搜索区域 -->
            <div class="search-con search-con-top">
              <Input
                class="search-input"
                v-model="graduateSearchVal"
                style="padding:5px; width: 300px;"
                placeholder="输入学校名称、专业搜索"
                @on-enter="handleGraduateSearch"
                clearable
              />
              <Button type="primary" icon="ios-search" @click="handleGraduateSearch" class="search-btn">搜索</Button>
              <Button type="primary" icon="ios-add" @click="showGraduateAddModal" class="search-btn">新增毕业信息</Button>
              <Button type="success" icon="ios-cloud-upload" @click="showGraduateImportModal" class="search-btn">导入</Button>
              <Button type="warning" icon="ios-download-outline" @click="handleGraduateExport" class="search-btn">导出</Button>
              <Button type="info" icon="ios-download-outline" @click="handleGraduateDownloadTemplate" class="search-btn">下载模板</Button>
            </div>

            <Spin size="large" fix v-if="graduateLoading"></Spin>

            <!-- 数据表格 -->
            <Table
              ref="graduateTable"
              :columns="graduateColumns"
              :data="graduateTableData"
              :loading="graduateLoading"
              border
              size="small"
            >
            </Table>

            <!-- 分页 -->
            <div class="pagination-con">
              <Page
                :total="graduateTotal"
                :page-size="graduatePageSize"
                :current="graduateCurrentPage"
                show-sizer
                show-total
                @on-change="handleGraduatePageChange"
                @on-page-size-change="handleGraduatePageSizeChange"
              />
            </div>
          </div>
        </TabPane>

        <TabPane label="招生信息管理" name="enroll">
          <div class="tab-content">
            <!-- 搜索区域 -->
            <div class="search-con search-con-top">
              <Input
                class="search-input"
                v-model="enrollSearchVal"
                style="padding:5px; width: 300px;"
                placeholder="输入学校名称、专业搜索"
                @on-enter="handleEnrollSearch"
                clearable
              />
              <Button type="primary" icon="ios-search" @click="handleEnrollSearch" class="search-btn">搜索</Button>
              <Button type="primary" icon="ios-add" @click="showEnrollAddModal" class="search-btn">新增招生信息</Button>
              <Button type="success" icon="ios-cloud-upload" @click="showEnrollImportModal" class="search-btn">导入</Button>
              <Button type="warning" icon="ios-download-outline" @click="handleEnrollExport" class="search-btn">导出</Button>
              <Button type="info" icon="ios-download-outline" @click="handleEnrollDownloadTemplate" class="search-btn">下载模板</Button>
            </div>

            <Spin size="large" fix v-if="enrollLoading"></Spin>

            <!-- 数据表格 -->
            <Table
              ref="enrollTable"
              :columns="enrollColumns"
              :data="enrollTableData"
              :loading="enrollLoading"
              border
              size="small"
            >
            </Table>

            <!-- 分页 -->
            <div class="pagination-con">
              <Page
                :total="enrollTotal"
                :page-size="enrollPageSize"
                :current="enrollCurrentPage"
                show-sizer
                show-total
                @on-change="handleEnrollPageChange"
                @on-page-size-change="handleEnrollPageSizeChange"
              />
            </div>
          </div>
        </TabPane>
      </Tabs>
    </Card>

    <!-- 学校信息新增/编辑模态框 -->
    <Modal
      v-model="schoolFormModal.visible"
      :title="schoolFormModal.title"
      :loading="schoolFormModal.loading"
      :footer-hide="true"
      :mask-closable="false"
      width="600"
    >
      <Form ref="schoolForm" :model="schoolFormData" :rules="schoolFormRules" :label-width="120">
        <FormItem label="学校名称" prop="school">
          <Input v-model="schoolFormData.school" placeholder="请输入学校名称" />
        </FormItem>
        <FormItem label="学校地址" prop="address">
          <Input v-model="schoolFormData.address" placeholder="请输入学校地址" />
        </FormItem>
        <FormItem label="学校介绍" prop="ntroduce">
          <Input v-model="schoolFormData.ntroduce" placeholder="请输入学校介绍" type="textarea" :rows="3" />
        </FormItem>
        <FormItem label="教育程度" prop="edu">
          <Input v-model="schoolFormData.edu" placeholder="请输入教育程度" />
        </FormItem>
        <FormItem label="学历" prop="educational">
          <Input v-model="schoolFormData.educational" placeholder="请输入学历" />
        </FormItem>
        <FormItem label="创建年份" prop="since">
          <Input v-model="schoolFormData.since" placeholder="请输入创建年份" />
        </FormItem>
        <FormItem label="联系电话" prop="phone">
          <Input v-model="schoolFormData.phone" placeholder="请输入联系电话" />
        </FormItem>
        <FormItem label="联系人" prop="linkman">
          <Input v-model="schoolFormData.linkman" placeholder="请输入联系人" />
        </FormItem>
        <FormItem label="学校logo" prop="logo">
          <Input v-model="schoolFormData.logo" placeholder="请输入学校logo" />
        </FormItem>
        <FormItem label="状态" prop="flag">
          <i-switch v-model="schoolFormData.flag" :true-value="0" :false-value="1">
            <span slot="open">有效</span>
            <span slot="close">无效</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSchoolSubmit">提交</Button>
          <Button @click="handleSchoolReset" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 毕业信息新增/编辑模态框 -->
    <Modal
      v-model="graduateFormModal.visible"
      :title="graduateFormModal.title"
      :loading="graduateFormModal.loading"
      :footer-hide="true"
      :mask-closable="false"
      width="600"
    >
      <Form ref="graduateForm" :model="graduateFormData" :rules="graduateFormRules" :label-width="120">
        <FormItem label="学校" prop="schoolid">
          <Select v-model="graduateFormData.schoolid" placeholder="请选择学校" style="width: 100%;" clearable>
            <Option v-for="school in schoolList" :value="school.id" :key="school.id">
              {{ school.school }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="毕业年份" prop="year">
          <InputNumber v-model="graduateFormData.year" :min="2000" :max="2100" style="width: 100%;" />
        </FormItem>
        <FormItem label="专业" prop="major">
          <Input v-model="graduateFormData.major" placeholder="请输入专业" />
        </FormItem>
        <FormItem label="学历" prop="educational">
          <Input v-model="graduateFormData.educational" placeholder="请输入学历" />
        </FormItem>
        <FormItem label="毕业人数" prop="num">
          <InputNumber v-model="graduateFormData.num" :min="0" style="width: 100%;" />
        </FormItem>
        <FormItem label="教育程度" prop="edu">
          <Input v-model="graduateFormData.edu" placeholder="请输入教育程度" />
        </FormItem>
        <FormItem label="状态" prop="flag">
          <i-switch v-model="graduateFormData.flag" :true-value="0" :false-value="1">
            <span slot="open">有效</span>
            <span slot="close">无效</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleGraduateSubmit">提交</Button>
          <Button @click="handleGraduateReset" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 招生信息新增/编辑模态框 -->
    <Modal
      v-model="enrollFormModal.visible"
      :title="enrollFormModal.title"
      :loading="enrollFormModal.loading"
      :footer-hide="true"
      :mask-closable="false"
      width="600"
    >
      <Form ref="enrollForm" :model="enrollFormData" :rules="enrollFormRules" :label-width="120">
        <FormItem label="学校" prop="schoolid">
          <Select v-model="enrollFormData.schoolid" placeholder="请选择学校" style="width: 100%;" clearable>
            <Option v-for="school in schoolList" :value="school.id" :key="school.id">
              {{ school.school }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="招生年份" prop="year">
          <InputNumber v-model="enrollFormData.year" :min="2000" :max="2100" style="width: 100%;" />
        </FormItem>
        <FormItem label="专业" prop="major">
          <Input v-model="enrollFormData.major" placeholder="请输入专业" />
        </FormItem>
        <FormItem label="学历" prop="educational">
          <Input v-model="enrollFormData.educational" placeholder="请输入学历" />
        </FormItem>
        <FormItem label="招生人数" prop="num">
          <InputNumber v-model="enrollFormData.num" :min="0" style="width: 100%;" />
        </FormItem>
        <FormItem label="状态" prop="flag">
          <i-switch v-model="enrollFormData.flag" :true-value="0" :false-value="1">
            <span slot="open">有效</span>
            <span slot="close">无效</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleEnrollSubmit">提交</Button>
          <Button @click="handleEnrollReset" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 学校信息导入模态框 -->
    <Modal
      v-model="schoolImportModal.visible"
      title="导入学校信息数据"
      :loading="schoolImportModal.loading"
      :footer-hide="true"
      width="500"
    >
      <Form ref="schoolImportForm" :model="schoolImportModal" :rules="schoolImportRules" :label-width="80">
        <FormItem label="选择文件" prop="file">
          <Upload
            ref="schoolUpload"
            :action="''"
            :auto-upload="false"
            :show-upload-list="false"
            :on-change="handleSchoolFileChange"
          >
            <Button icon="ios-cloud-upload">选择Excel文件</Button>
          </Upload>
          <div v-if="schoolImportModal.fileName" class="file-name">
            已选择文件: {{ schoolImportModal.fileName }}
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSchoolImport" :disabled="!schoolImportModal.fileName">导入</Button>
          <Button @click="handleSchoolCancelImport" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 毕业信息导入模态框 -->
    <Modal
      v-model="graduateImportModal.visible"
      title="导入毕业信息数据"
      :loading="graduateImportModal.loading"
      :footer-hide="true"
      width="500"
    >
      <Form ref="graduateImportForm" :model="graduateImportModal" :rules="graduateImportRules" :label-width="80">
        <FormItem label="选择文件" prop="file">
          <Upload
            ref="graduateUpload"
            :action="''"
            :auto-upload="false"
            :show-upload-list="false"
            :on-change="handleGraduateFileChange"
          >
            <Button icon="ios-cloud-upload">选择Excel文件</Button>
          </Upload>
          <div v-if="graduateImportModal.fileName" class="file-name">
            已选择文件: {{ graduateImportModal.fileName }}
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleGraduateImport" :disabled="!graduateImportModal.fileName">导入</Button>
          <Button @click="handleGraduateCancelImport" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 招生信息导入模态框 -->
    <Modal
      v-model="enrollImportModal.visible"
      title="导入招生信息数据"
      :loading="enrollImportModal.loading"
      :footer-hide="true"
      width="500"
    >
      <Form ref="enrollImportForm" :model="enrollImportModal" :rules="enrollImportRules" :label-width="80">
        <FormItem label="选择文件" prop="file">
          <Upload
            ref="enrollUpload"
            :action="''"
            :auto-upload="false"
            :show-upload-list="false"
            :on-change="handleEnrollFileChange"
          >
            <Button icon="ios-cloud-upload">选择Excel文件</Button>
          </Upload>
          <div v-if="enrollImportModal.fileName" class="file-name">
            已选择文件: {{ enrollImportModal.fileName }}
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleEnrollImport" :disabled="!enrollImportModal.fileName">导入</Button>
          <Button @click="handleEnrollCancelImport" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import {
  getSchoolList,
  createSchool,
  updateSchool,
  deleteSchool,
  importSchool,
  exportSchool,
  getSchoolTemplate,
  getGraduateList,
  createGraduate,
  updateGraduate,
  deleteGraduate,
  importGraduate,
  exportGraduate,
  getGraduateTemplate,
  getEnrollList,
  createEnroll,
  updateEnroll,
  deleteEnroll,
  importEnroll,
  exportEnroll,
  getEnrollTemplate
} from '@/api/school/school.js'

export default {
  name: 'SchoolManage',
  data () {
    return {
      activeTab: 'school',
      schoolList: [],

      // 学校信息
      schoolSearchVal: '',
      schoolLoading: false,
      schoolTableData: [],
      schoolTotal: 0,
      schoolCurrentPage: 1,
      schoolPageSize: 10,

      // 学校信息表单模态框
      schoolFormModal: {
        visible: false,
        title: '新增学校信息',
        loading: false,
        isEdit: false
      },

      // 学校信息表单数据
      schoolFormData: {
        id: null,
        school: '',
        address: '',
        ntroduce: '',
        edu: '',
        educational: '',
        since: '',
        phone: '',
        linkman: '',
        logo: '',
        flag: 0
      },

      // 学校信息表单验证规则
      schoolFormRules: {
        school: [
          { required: true, message: '学校名称不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '学校地址不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' }
        ],
        linkman: [
          { required: true, message: '联系人不能为空', trigger: 'blur' }
        ]
      },

      // 学校信息导入模态框
      schoolImportModal: {
        visible: false,
        loading: false,
        file: null,
        fileName: ''
      },

      schoolImportRules: {
        file: [
          { required: true, message: '请选择Excel文件', trigger: 'change' }
        ]
      },

      // 毕业信息
      graduateSearchVal: '',
      graduateLoading: false,
      graduateTableData: [],
      graduateTotal: 0,
      graduateCurrentPage: 1,
      graduatePageSize: 10,

      // 毕业信息表单模态框
      graduateFormModal: {
        visible: false,
        title: '新增毕业信息',
        loading: false,
        isEdit: false
      },

      // 毕业信息表单数据
      graduateFormData: {
        id: null,
        schoolid: null,
        year: new Date().getFullYear(),
        major: '',
        educational: '',
        num: 0,
        edu: '',
        flag: 0
      },

      // 毕业信息表单验证规则
      graduateFormRules: {
        schoolid: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ],
        year: [
          { required: true, message: '毕业年份不能为空', trigger: 'blur' }
        ],
        major: [
          { required: true, message: '专业不能为空', trigger: 'blur' }
        ],
        educational: [
          { required: true, message: '学历不能为空', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '毕业人数不能为空', trigger: 'blur' }
        ]
      },

      // 毕业信息导入模态框
      graduateImportModal: {
        visible: false,
        loading: false,
        file: null,
        fileName: ''
      },

      graduateImportRules: {
        file: [
          { required: true, message: '请选择Excel文件', trigger: 'change' }
        ]
      },

      // 招生信息
      enrollSearchVal: '',
      enrollLoading: false,
      enrollTableData: [],
      enrollTotal: 0,
      enrollCurrentPage: 1,
      enrollPageSize: 10,

      // 招生信息表单模态框
      enrollFormModal: {
        visible: false,
        title: '新增招生信息',
        loading: false,
        isEdit: false
      },

      // 招生信息表单数据
      enrollFormData: {
        id: null,
        schoolid: null,
        year: new Date().getFullYear(),
        major: '',
        educational: '',
        num: 0,
        flag: 0
      },

      // 招生信息表单验证规则
      enrollFormRules: {
        schoolid: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ],
        year: [
          { required: true, message: '招生年份不能为空', trigger: 'blur' }
        ],
        major: [
          { required: true, message: '专业不能为空', trigger: 'blur' }
        ],
        educational: [
          { required: true, message: '学历不能为空', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '招生人数不能为空', trigger: 'blur' }
        ]
      },

      // 招生信息导入模态框
      enrollImportModal: {
        visible: false,
        loading: false,
        file: null,
        fileName: ''
      },

      enrollImportRules: {
        file: [
          { required: true, message: '请选择Excel文件', trigger: 'change' }
        ]
      },

      // 学校信息表格列配置
      schoolColumns: [
        {
          title: '学校名称',
          key: 'school',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '学校地址',
          key: 'address',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '联系人',
          key: 'linkman',
          width: 100
        },
        {
          title: '联系电话',
          key: 'phone',
          width: 120
        },
        {
          title: '邮箱',
          key: 'email',
          width: 150
        },
        {
          title: '状态',
          key: 'flag',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.flag === 0 ? 'success' : 'default'
              }
            }, params.row.flag === 0 ? '有效' : '无效')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const buttons = [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => this.showSchoolEditModal(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.handleSchoolDelete(params.row) }
              }, '删除')
            ]
            return h('div', buttons)
          }
        }
      ],

      // 毕业信息表格列配置
      graduateColumns: [
        {
          title: '学校名称',
          key: 'school_name',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '毕业年份',
          key: 'year',
          width: 120
        },
        {
          title: '专业',
          key: 'major',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '学历',
          key: 'educational',
          width: 100,
          align: 'center'
        },
        {
          title: '毕业人数',
          key: 'num',
          width: 100,
          align: 'center'
        },
        {
          title: '教育程度',
          key: 'edu',
          width: 100,
          align: 'center'
        },
        {
          title: '状态',
          key: 'flag',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.flag === 0 ? 'success' : 'default'
              }
            }, params.row.flag === 0 ? '有效' : '无效')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const buttons = [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => this.showGraduateEditModal(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.handleGraduateDelete(params.row) }
              }, '删除')
            ]
            return h('div', buttons)
          }
        }
      ],

      // 招生信息表格列配置
      enrollColumns: [
        {
          title: '学校名称',
          key: 'school_name',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '招生年份',
          key: 'year',
          width: 120
        },
        {
          title: '专业',
          key: 'major',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '学历',
          key: 'educational',
          width: 100,
          align: 'center'
        },
        {
          title: '招生人数',
          key: 'num',
          width: 120,
          align: 'center'
        },
        {
          title: '状态',
          key: 'flag',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.flag === 0 ? 'success' : 'default'
              }
            }, params.row.flag === 0 ? '有效' : '无效')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const buttons = [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => this.showEnrollEditModal(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.handleEnrollDelete(params.row) }
              }, '删除')
            ]
            return h('div', buttons)
          }
        }
      ]
    }
  },

  computed: {
    // 保留空的 computed，后续可添加其他计算属性
  },

  methods: {
    // 获取学校列表（用于下拉选择）
    async getSchoolList () {
      try {
        const res = await getSchoolList({ page: 1, limit: 1000 })
        if (res.data.code === 200 || res.data.code === 0) {
          this.schoolList = res.data.data.list || []
        }
      } catch (error) {
        console.error('获取学校列表失败:', error)
      }
    },

    // 获取学校信息列表
    async getSchoolListData () {
      this.schoolLoading = true
      try {
        const params = {
          page: this.schoolCurrentPage,
          limit: this.schoolPageSize
        }
        if (this.schoolSearchVal) {
          params.keyword = this.schoolSearchVal
        }
        const res = await getSchoolList(params)
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data
          this.schoolTableData = data.list || []
          this.schoolTotal = data.total || 0
        } else {
          this.$Message.error(res.data.message || '获取数据失败')
        }
      } catch (error) {
        this.$Message.error('获取数据失败: ' + error.message)
      } finally {
        this.schoolLoading = false
      }
    },

    // 获取毕业信息列表
    async getGraduateListData () {
      this.graduateLoading = true
      try {
        const params = {
          page: this.graduateCurrentPage,
          limit: this.graduatePageSize
        }
        if (this.graduateSearchVal) {
          params.keyword = this.graduateSearchVal
        }
        const res = await getGraduateList(params)
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data
          this.graduateTableData = data.list || []
          this.graduateTotal = data.total || 0
        } else {
          this.$Message.error(res.data.message || '获取数据失败')
        }
      } catch (error) {
        this.$Message.error('获取数据失败: ' + error.message)
      } finally {
        this.graduateLoading = false
      }
    },

    // 获取招生信息列表
    async getEnrollListData () {
      this.enrollLoading = true
      try {
        const params = {
          page: this.enrollCurrentPage,
          limit: this.enrollPageSize
        }
        if (this.enrollSearchVal) {
          params.keyword = this.enrollSearchVal
        }
        const res = await getEnrollList(params)
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data
          this.enrollTableData = data.list || []
          this.enrollTotal = data.total || 0
        } else {
          this.$Message.error(res.data.message || '获取数据失败')
        }
      } catch (error) {
        this.$Message.error('获取数据失败: ' + error.message)
      } finally {
        this.enrollLoading = false
      }
    },

    // 学校信息搜索
    handleSchoolSearch () {
      this.schoolCurrentPage = 1
      this.getSchoolListData()
    },

    // 学校信息分页
    handleSchoolPageChange (page) {
      this.schoolCurrentPage = page
      this.getSchoolListData()
    },

    handleSchoolPageSizeChange (size) {
      this.schoolPageSize = size
      this.schoolCurrentPage = 1
      this.getSchoolListData()
    },

    // 毕业信息搜索
    handleGraduateSearch () {
      this.graduateCurrentPage = 1
      this.getGraduateListData()
    },

    // 毕业信息分页
    handleGraduatePageChange (page) {
      this.graduateCurrentPage = page
      this.getGraduateListData()
    },

    handleGraduatePageSizeChange (size) {
      this.graduatePageSize = size
      this.graduateCurrentPage = 1
      this.getGraduateListData()
    },

    // 招生信息搜索
    handleEnrollSearch () {
      this.enrollCurrentPage = 1
      this.getEnrollListData()
    },

    // 招生信息分页
    handleEnrollPageChange (page) {
      this.enrollCurrentPage = page
      this.getEnrollListData()
    },

    handleEnrollPageSizeChange (size) {
      this.enrollPageSize = size
      this.enrollCurrentPage = 1
      this.getEnrollListData()
    },

    // 学校信息新增
    showSchoolAddModal () {
      this.schoolFormModal.visible = true
      this.schoolFormModal.title = '新增学校信息'
      this.schoolFormModal.isEdit = false
      this.schoolFormData = {
        id: null,
        school: '',
        address: '',
        ntroduce: '',
        edu: '',
        educational: '',
        since: '',
        phone: '',
        linkman: '',
        logo: '',
        flag: 0
      }
    },

    // 学校信息编辑
    showSchoolEditModal (row) {
      this.schoolFormModal.visible = true
      this.schoolFormModal.title = '编辑学校信息'
      this.schoolFormModal.isEdit = true
      this.schoolFormData = {
        id: row.id,
        school: row.school,
        address: row.address,
        ntroduce: row.ntroduce,
        edu: row.edu,
        educational: row.educational,
        since: row.since,
        phone: row.phone,
        linkman: row.linkman,
        logo: row.logo,
        flag: row.flag
      }
    },

    // 学校信息提交
    handleSchoolSubmit () {
      this.$refs.schoolForm.validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请检查表单填写')
          return
        }

        this.schoolFormModal.loading = true
        try {
          const submitData = {
            school: this.schoolFormData.school,
            address: this.schoolFormData.address,
            ntroduce: this.schoolFormData.ntroduce,
            edu: this.schoolFormData.edu,
            educational: this.schoolFormData.educational,
            since: this.schoolFormData.since,
            phone: this.schoolFormData.phone,
            linkman: this.schoolFormData.linkman,
            logo: this.schoolFormData.logo,
            flag: this.schoolFormData.flag
          }

          let res
          if (this.schoolFormModal.isEdit) {
            res = await updateSchool(this.schoolFormData.id, submitData)
          } else {
            res = await createSchool(submitData)
          }

          if (res.data.code === 200 || res.data.code === 0) {
            this.$Message.success(this.schoolFormModal.isEdit ? '修改成功' : '添加成功')
            this.schoolFormModal.visible = false
            this.getSchoolListData()
            this.getSchoolList() // 更新学校列表
          } else {
            this.$Message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          this.$Message.error('操作失败: ' + error.message)
        } finally {
          this.schoolFormModal.loading = false
        }
      })
    },

    // 学校信息重置
    handleSchoolReset () {
      this.$refs.schoolForm.resetFields()
    },

    // 学校信息删除
    handleSchoolDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除学校信息"${row.schoolName}"吗？`,
        onOk: async () => {
          try {
            const res = await deleteSchool(row.id)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getSchoolListData()
              this.getSchoolList() // 更新学校列表
            } else {
              this.$Message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败: ' + error.message)
          }
        }
      })
    },

    // 毕业信息新增
    showGraduateAddModal () {
      this.graduateFormModal.visible = true
      this.graduateFormModal.title = '新增毕业信息'
      this.graduateFormModal.isEdit = false
      this.graduateFormData = {
        id: null,
        schoolid: null,
        year: new Date().getFullYear(),
        major: '',
        educational: '',
        num: 0,
        edu: '',
        flag: 0
      }
    },

    // 毕业信息编辑
    showGraduateEditModal (row) {
      this.graduateFormModal.visible = true
      this.graduateFormModal.title = '编辑毕业信息'
      this.graduateFormModal.isEdit = true
      this.graduateFormData = {
        id: row.id,
        schoolid: row.schoolid,
        year: row.year,
        major: row.major,
        educational: row.educational,
        num: row.num,
        edu: row.edu,
        flag: row.flag
      }
    },

    // 毕业信息提交
    handleGraduateSubmit () {
      this.$refs.graduateForm.validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请检查表单填写')
          return
        }

        this.graduateFormModal.loading = true
        try {
          const submitData = {
            schoolid: this.graduateFormData.schoolid,
            year: this.graduateFormData.year,
            major: this.graduateFormData.major,
            educational: this.graduateFormData.educational,
            num: this.graduateFormData.num,
            edu: this.graduateFormData.edu,
            flag: this.graduateFormData.flag
          }

          let res
          if (this.graduateFormModal.isEdit) {
            res = await updateGraduate(this.graduateFormData.id, submitData)
          } else {
            res = await createGraduate(submitData)
          }

          if (res.data.code === 200 || res.data.code === 0) {
            this.$Message.success(this.graduateFormModal.isEdit ? '修改成功' : '添加成功')
            this.graduateFormModal.visible = false
            this.getGraduateListData()
          } else {
            this.$Message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          this.$Message.error('操作失败: ' + error.message)
        } finally {
          this.graduateFormModal.loading = false
        }
      })
    },

    // 毕业信息重置
    handleGraduateReset () {
      this.$refs.graduateForm.resetFields()
    },

    // 毕业信息删除
    handleGraduateDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除毕业信息吗？`,
        onOk: async () => {
          try {
            const res = await deleteGraduate(row.id)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getGraduateListData()
            } else {
              this.$Message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败: ' + error.message)
          }
        }
      })
    },

    // 招生信息新增
    showEnrollAddModal () {
      this.enrollFormModal.visible = true
      this.enrollFormModal.title = '新增招生信息'
      this.enrollFormModal.isEdit = false
      this.enrollFormData = {
        id: null,
        schoolid: null,
        year: new Date().getFullYear(),
        major: '',
        educational: '',
        num: 0,
        flag: 0
      }
    },

    // 招生信息编辑
    showEnrollEditModal (row) {
      this.enrollFormModal.visible = true
      this.enrollFormModal.title = '编辑招生信息'
      this.enrollFormModal.isEdit = true
      this.enrollFormData = {
        id: row.id,
        schoolid: row.schoolid,
        year: row.year,
        major: row.major,
        educational: row.educational,
        num: row.num,
        flag: row.flag
      }
    },

    // 招生信息提交
    handleEnrollSubmit () {
      this.$refs.enrollForm.validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请检查表单填写')
          return
        }

        this.enrollFormModal.loading = true
        try {
          const submitData = {
            schoolid: this.enrollFormData.schoolid,
            year: this.enrollFormData.year,
            major: this.enrollFormData.major,
            educational: this.enrollFormData.educational,
            num: this.enrollFormData.num,
            flag: this.enrollFormData.flag
          }

          let res
          if (this.enrollFormModal.isEdit) {
            res = await updateEnroll(this.enrollFormData.id, submitData)
          } else {
            res = await createEnroll(submitData)
          }

          if (res.data.code === 200 || res.data.code === 0) {
            this.$Message.success(this.enrollFormModal.isEdit ? '修改成功' : '添加成功')
            this.enrollFormModal.visible = false
            this.getEnrollListData()
          } else {
            this.$Message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          this.$Message.error('操作失败: ' + error.message)
        } finally {
          this.enrollFormModal.loading = false
        }
      })
    },

    // 招生信息重置
    handleEnrollReset () {
      this.$refs.enrollForm.resetFields()
    },

    // 招生信息删除
    handleEnrollDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除招生信息吗？`,
        onOk: async () => {
          try {
            const res = await deleteEnroll(row.id)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getEnrollListData()
            } else {
              this.$Message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败: ' + error.message)
          }
        }
      })
    },

    // 学校信息导入
    showSchoolImportModal () {
      this.schoolImportModal.visible = true
      this.schoolImportModal.file = null
      this.schoolImportModal.fileName = ''
    },

    handleSchoolFileChange (file) {
      this.schoolImportModal.file = file.file
      this.schoolImportModal.fileName = file.name
    },

    async handleSchoolImport () {
      if (!this.schoolImportModal.file) {
        this.$Message.warning('请选择要导入的Excel文件')
        return
      }

      const formData = new FormData()
      formData.append('file', this.schoolImportModal.file)

      this.schoolImportModal.loading = true
      try {
        const res = await importSchool(formData)
        if (res.data.code === 200 || res.data.code === 0) {
          this.$Message.success('导入成功')
          this.schoolImportModal.visible = false
          this.getSchoolListData()
          this.getSchoolList()
        } else {
          this.$Message.error(res.data.message || '导入失败')
        }
      } catch (error) {
        this.$Message.error('导入失败: ' + error.message)
      } finally {
        this.schoolImportModal.loading = false
      }
    },

    handleSchoolCancelImport () {
      this.schoolImportModal.visible = false
      this.schoolImportModal.file = null
      this.schoolImportModal.fileName = ''
    },

    // 学校信息导出
    async handleSchoolExport () {
      try {
        const params = {}
        if (this.schoolSearchVal) {
          params.keyword = this.schoolSearchVal
        }
        const res = await exportSchool(params)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '学校信息数据.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('导出成功')
      } catch (error) {
        this.$Message.error('导出失败: ' + error.message)
      }
    },

    // 学校信息导入模板下载
    async handleSchoolDownloadTemplate () {
      try {
        const res = await getSchoolTemplate()
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '学校信息导入模板.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('模板下载成功')
      } catch (error) {
        this.$Message.error('下载失败: ' + error.message)
      }
    },

    // 毕业信息导入
    showGraduateImportModal () {
      this.graduateImportModal.visible = true
      this.graduateImportModal.file = null
      this.graduateImportModal.fileName = ''
    },

    handleGraduateFileChange (file) {
      this.graduateImportModal.file = file.file
      this.graduateImportModal.fileName = file.name
    },

    async handleGraduateImport () {
      if (!this.graduateImportModal.file) {
        this.$Message.warning('请选择要导入的Excel文件')
        return
      }

      const formData = new FormData()
      formData.append('file', this.graduateImportModal.file)

      this.graduateImportModal.loading = true
      try {
        const res = await importGraduate(formData)
        if (res.data.code === 200 || res.data.code === 0) {
          this.$Message.success('导入成功')
          this.graduateImportModal.visible = false
          this.getGraduateListData()
        } else {
          this.$Message.error(res.data.message || '导入失败')
        }
      } catch (error) {
        this.$Message.error('导入失败: ' + error.message)
      } finally {
        this.graduateImportModal.loading = false
      }
    },

    handleGraduateCancelImport () {
      this.graduateImportModal.visible = false
      this.graduateImportModal.file = null
      this.graduateImportModal.fileName = ''
    },

    // 毕业信息导出
    async handleGraduateExport () {
      try {
        const params = {}
        if (this.graduateSearchVal) {
          params.keyword = this.graduateSearchVal
        }
        const res = await exportGraduate(params)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '毕业信息数据.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('导出成功')
      } catch (error) {
        this.$Message.error('导出失败: ' + error.message)
      }
    },

    // 毕业信息导入模板下载
    async handleGraduateDownloadTemplate () {
      try {
        const res = await getGraduateTemplate()
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '毕业信息导入模板.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('模板下载成功')
      } catch (error) {
        this.$Message.error('下载失败: ' + error.message)
      }
    },

    // 招生信息导入
    showEnrollImportModal () {
      this.enrollImportModal.visible = true
      this.enrollImportModal.file = null
      this.enrollImportModal.fileName = ''
    },

    handleEnrollFileChange (file) {
      this.enrollImportModal.file = file.file
      this.enrollImportModal.fileName = file.name
    },

    async handleEnrollImport () {
      if (!this.enrollImportModal.file) {
        this.$Message.warning('请选择要导入的Excel文件')
        return
      }

      const formData = new FormData()
      formData.append('file', this.enrollImportModal.file)

      this.enrollImportModal.loading = true
      try {
        const res = await importEnroll(formData)
        if (res.data.code === 200 || res.data.code === 0) {
          this.$Message.success('导入成功')
          this.enrollImportModal.visible = false
          this.getEnrollListData()
        } else {
          this.$Message.error(res.data.message || '导入失败')
        }
      } catch (error) {
        this.$Message.error('导入失败: ' + error.message)
      } finally {
        this.enrollImportModal.loading = false
      }
    },

    handleEnrollCancelImport () {
      this.enrollImportModal.visible = false
      this.enrollImportModal.file = null
      this.enrollImportModal.fileName = ''
    },

    // 招生信息导出
    async handleEnrollExport () {
      try {
        const params = {}
        if (this.enrollSearchVal) {
          params.keyword = this.enrollSearchVal
        }
        const res = await exportEnroll(params)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '招生信息数据.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('导出成功')
      } catch (error) {
        this.$Message.error('导出失败: ' + error.message)
      }
    },

    // 招生信息导入模板下载
    async handleEnrollDownloadTemplate () {
      try {
        const res = await getEnrollTemplate()
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '招生信息导入模板.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('模板下载成功')
      } catch (error) {
        this.$Message.error('下载失败: ' + error.message)
      }
    }
  },

  mounted () {
    this.getSchoolList()
    this.getSchoolListData()
    this.getGraduateListData()
    this.getEnrollListData()
  }
}
</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search-input {
    display: inline-block;
    margin-right: 10px;
  }

  .search-btn {
    margin-left: 5px;
  }
}

.pagination-con {
  text-align: right;
  margin-top: 15px;
}

.file-name {
  margin-top: 10px;
  color: #808695;
  font-size: 13px;
}

.tab-content {
  padding-top: 10px;
}
</style>
